import { createContext } from 'react';

const AddedModsContext = createContext({
  addedMods: [],
  setAddedMods: () => {},
  refreshAddedMods: false,
  setRefreshAddedMods: () => {}
})

export default AddedModsContext;